<template>
    <app-modal
        v-if="isPolicyDetailsOpen"
        class="quote-policy-details"
        hasCloseButton
        small
        @handle-close="handleClose"
    >
        <template v-slot:default>
            <!-- <div class="logo-container">
                <img
                    :alt="selectedQuote.company"
                    :src="selectedQuote.logo"
                    :title="selectedQuote.company"
                />
            </div> -->
            <div class="text-center" v-if="quoteType === 'pet'">
                {{ ("quote-results.pet.branch_" + selectedQuote.branch) | __ }}
            </div>

            <div class="price-container flex">
                <p class="items-end">
                    {{ selectedQuote.total }} <span>{{ currency }}</span>
                </p>
                <div
                    v-if="quoteType === 'pet'"
                    class="flex items-end mr-2 text-sm text-gray-500 p-2"
                >
                    {{ "quote-results.pet.month" | __ }}
                </div>
            </div>

            <div class="price-details-container">
                <div
                    v-for="(line, j) in selectedQuote.lines"
                    class="detail-item"
                    :key="j"
                >
                    <div class="type">
                        <p>
                            {{ line.label }}:
                            <span>{{ line.value }} {{ currency }}</span>
                        </p>
                    </div>
                </div>
            </div>

            <div
                class="policy-include-container"
                v-if="quoteType === 'car' || quoteType === 'home'"
            >
                <div class="include-item">
                    <p class="no-mark">
                        {{ `quote-results.static.policy_includes` | __ }}
                    </p>
                </div>

                <template v-for="(value, key) in policyIncludes">
                    <div :key="key" class="include-item">
                        <span class="check-icon"></span>
                        <span class="text-sm">
                            {{ `quote-results.${quoteType}.${key}` | __ }}
                        </span>
                    </div>
                </template>
            </div>

            <div class="policy-details-container">
                <div class="policy-details-item">
                    <div class="title">
                        <p>{{ policyDetails("title") }}</p>
                    </div>

                    <div
                        v-if="
                            quoteType === 'pet' &&
                                selectedQuote.branch === subtitle
                        "
                        v-for="(value, subtitle, index) in policyDetails(
                            'subtitle'
                        )"
                        :style="{
                            'flex-direction':
                                quoteType === 'pet' ? 'column' : 'row'
                        }"
                        :key="index"
                    >
                        <div
                            v-if="quoteType === 'pet'"
                            v-for="(pet_value, pet_subtitle) in value"
                            class="sub-title"
                            :key="pet_subtitle"
                        >
                            <p>{{ translateSubtitle(pet_subtitle) }}</p>
                            <span>{{ getValueOrUnlimited(pet_value) }}</span>
                        </div>
                    </div>
                    <div
                        v-if="quoteType !== 'pet'"
                        v-for="(value, subtitle, index) in policyDetails(
                            'subtitle'
                        )"
                        :style="{
                            'flex-direction':
                                quoteType === 'pet' ? 'column' : 'row'
                        }"
                        :key="index"
                    >
                        <div class="sub-title">
                            <p>{{ translateSubtitle(subtitle) }}</p>
                            <span>{{ getValueOrUnlimited(value) }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="note">
                <p>{{ translateNote() }}</p>
            </div>
        </template>
    </app-modal>
</template>

<script>
import trans from "../../trans";

export default {
    props: {
        isPolicyDetailsOpen: Boolean,
        selectedQuote: Object,
        quoteType: String,
        currency: String,
        policyIncludes: Object
    },
    methods: {
        trans,
        handleClose() {
            this.$emit("close-policy-details"); // Emit an event to notify the parent
        },
        policyDetails(title) {
            return this.selectedQuote.policyDetails[this.quoteType][title];
        },
        translateSubtitle(subtitle) {
            return this.trans(`quote-results.${this.quoteType}.${subtitle}`);
        },
        getValueOrUnlimited(value) {
            if (value === null) {
                return this.trans("quote-results.static.notAvailable");
            } else if (value === -1) {
                return this.trans("quote-results.static.unlimited");
            } else if (value.includes("%")) {
                return value;
            }
            return `${value} ${this.currency}`;
        },
        translateNote() {
            return this.trans(`quote-results.${this.quoteType}.note`);
        }
    }
};
</script>

<style lang="scss" scoped>
.quote-policy-details {
    .modal-body {
        border-radius: 15px;
        max-width: 600px;
        min-height: 250px;
        height: fit-content;
        max-height: 100%;
        overflow: auto;

        > div {
            margin-top: 20px;

            @media (max-width: $mobile) {
                margin-top: 0;
            }
        }

        .protection-info {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            flex: 1;
        }

        .protection-info > div {
            text-align: center;
        }

        .protection-info--title {
            color: var(--blue, $primary-blue);
            font-size: 35px;
            font-weight: $font-bold;
        }

        .protection-info--subtitle {
            color: $black;
            font-size: 18px;
            font-weight: $font-semi-bold;
        }

        .logo-container {
            display: flex;
            flex-direction: row;
            justify-content: center;
            width: 190px;
            border-radius: 70px;
            border: 1px solid $black;
            background: $white;
            height: 68px;
            margin: 10px auto;

            @media (max-width: $mobile) {
                width: 126px;
                height: 45px;
            }

            img {
                width: 70%;
                height: auto;
                object-position: center;
                padding: 10px;
                object-fit: cover;

                @media (max-width: $mobile) {
                    padding: 5px 0;
                    width: auto;
                    height: auto;
                    object-fit: contain;
                }
            }
        }

        .price-container {
            @media (max-width: $mobile) {
                margin: 0 auto;
            }

            p {
                color: var(--blue, $primary-blue);
                font-size: $font-size-desktop;
                font-weight: $font-bold;
            }
        }

        .price-details-container {
            width: 100%;
            display: flex;
            justify-content: space-between;

            p {
                color: $black;
                text-align: center;
                font-size: 16px;

                span {
                    font-size: 20px;
                    font-weight: $font-bold;
                }
            }

            @media (max-width: $mobile) {
                p {
                    font-size: 14px;

                    span {
                        font-size: 14px;
                    }
                }
            }
        }

        .policy-include-container {
            display: flex;
            border-radius: 5px;
            background: linear-gradient(90deg, $primary-blue 0%, $cyan 100%);
            height: 70px;
            padding: 15px 35px;
            justify-content: space-around;
            align-content: center;
            color: #fff;

            @media (max-width: $mobile) {
                flex-direction: column;
                height: 100%;
                padding: 15px 55px;
            }

            .include-item {
                display: flex;
                justify-content: space-around;
                align-items: center;
                color: #fff;

                @media (max-width: $mobile) {
                    display: grid;
                    grid-template-columns: 1fr 2fr;
                    align-items: center;

                    &:first-of-type {
                        grid-template-columns: 100%;
                        text-align: center;

                        p {
                            justify-content: center;
                        }
                    }
                }

                p {
                    position: relative;
                    color: $white;
                    display: flex;
                    align-items: center;
                    font-size: 20px;
                    font-weight: $font-normal;

                    @media (max-width: $mobile) {
                        font-size: 15px;
                    }

                    // &:not(.no-mark) {
                    //     &:after {

                    //     }
                    // }
                }

                .check-icon {
                    display: block;
                    width: 30px;
                    background-image: url("data:image/svg+xml,%0A%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='Frame'%3E%3Cpath id='Vector' d='M8 12.4286L10.538 15L16 9' stroke='%2338DBBC' stroke-linecap='round'/%3E%3Cpath id='Vector_2' d='M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z' stroke='%2338DBBC'/%3E%3C/g%3E%3C/svg%3E ");
                    background-repeat: no-repeat;
                    height: 25px;
                }
            }
        }

        .policy-details-container {
            display: flex;
            flex-direction: column;

            > div {
                margin: 0 auto;
                width: 100%;
            }

            .policy-details-item {
                .title {
                    margin: 15px 0;
                    padding-bottom: 10px;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

                    p {
                        color: $black;
                        font-size: 20px;
                        font-weight: $font-semi-bold;

                        @media (max-width: $mobile) {
                            font-size: 15px;
                        }
                    }
                }

                .sub-title {
                    margin: 15px 0;
                    padding-bottom: 10px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

                    p {
                        color: $black;
                        font-size: 20px;
                        font-weight: $font-normal;

                        @media (max-width: $mobile) {
                            font-size: 15px;
                        }
                    }

                    span {
                        color: $black;
                        font-size: 20px;
                        font-weight: $font-bold;

                        @media (max-width: $mobile) {
                            font-size: 15px;
                        }
                    }
                }
            }
        }

        .note {
            p {
                color: $error-red;
                text-align: right;
                font-size: 18px;
                font-weight: $font-semi-bold;

                @media (max-width: $mobile) {
                    font-size: 13px;
                }
            }
        }
    }
}
</style>
